import frontendConfig from "../../helpers/frontendConfig";
import moment from "moment";

export default {
    mixins: [],
    data: () => ({
        date: Number(frontendConfig.albumSearchDays || 30)
    }),
    computed: {
        //Computo para obtener los Paises cuando tengan un cambio en la variable
        getCountries: {
            get: function() {
                return this.$store.getters.Contries;
            }
        },
        //Computo para obtener las ciudades cuando tengan un cambio en la variable
        getCountryStates: {
            get: function() {
                return this.$store.getters.CountryStates;
            }
        },
    },
    methods: {
        disabledBeforeTodayAndAfterAWeek(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return (
                date < new Date(today.getTime() - this.date * 24 * 3600 * 1000) ||
                date > today
            );
        },
        /**
         * It takes an array of objects as an argument, and then it dispatches an action called
         * setContries, which is defined in the store.js file
         * @param data - The data to be sent to the store.
         * @returns The return value of the dispatch function.
         */
        setContries(data) {
            return this.$store.dispatch("setContries", data);
        },
        /**
         * It takes a data object, and dispatches the setCountryStates action with the data object as a
         * parameter
         * @param data - The data to be sent to the server.
         * @returns The return value of the dispatch function.
         */
        setCountryStates(data) {
            return this.$store.dispatch("setCountryStates", data);
        },
        /**
         * It takes a ParkId as an argument, and returns the ParkName of the park with that ParkId
         * @param ParkId - The ID of the park you want to get the name of.
         * @returns The park name of the park with the given ID.
         */
        getParkName(ParkId) {
            const park = Object.values(this.$store.state.Parks).find(element => element.ParkId == ParkId);

            return park.ParkName;
        },
        /**
         * It takes a ParkId as an argument, and returns the Park object from the Parks array in the
         * Vuex store that has a matching ParkId
         * @param ParkId - The ID of the park you want to get the details for.
         * @returns The park object that matches the ParkId
         */
        getParkDetail(ParkId) {
            const park = Object.values(this.$store.state.Parks).find(element => element.ParkId == ParkId);

            return park;
        },
        /**
         * It takes a date and returns a string with the date formatted in the language of the user's
         * browser
         * @param date - The date to format.
         * @returns A string with the date in the format "dddd, MMMM YYYY"
         */
        dateString(date) {
            const lang = document.documentElement.lang;
            moment.locale(lang);
            return moment(date).format("dddd, MMMM YYYY");
        },
        /**
         * It takes an object, a key to search for, and an array to store the results in. It then loops
         * through the object, and if the key matches the search key, it pushes the value to the
         * results array. If the value is an object, it calls itself again with the value as the
         * object, the search key, and the results array
         * @param obj - The object to search through
         * @param searchKey - The key you want to search for
         * @param [results] - This is the array that will be returned.
         */
        flatten(obj, searchKey, results = []) {
            const r = results;
            Object.keys(obj).forEach(key => {
                const value = obj[key];
                if (key === searchKey && typeof value !== 'object') {
                    r.push(value);
                } else if (typeof value === 'object') {
                    this.flatten(value, searchKey, r);
                }
            });

            return r;
        },
        /**
         * It will allow only numbers and dot in the input field
         * @param  - The event object
         */
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                // 46 is dot
                $event.preventDefault();
            }
        }
    }
};